import React, { FC } from "react";
import { Switch, Redirect, RouteComponentProps } from "react-router-dom";
import ParamsProvider from "src/app/common/components/ParamsProvider";
import MdrtPassportBackgroundDetailPage from "./Create/MdrtPassportBackgroundDetailPage";
import PruRoute from "src/app/common/components/PruRoute";
import { NOT_FOUND_ERROR_PAGE_PATH } from "src/app/common/constants";
import { MDRT_HUB_BASE_PATH, MDRT_PASSPORT_BACKGROUND_BASE_PATH } from "../../constants";
import MdrtPassportBackgroundListingPage from "./List/MdrtPassportBackgroundListingPage";

const MdrtPassportBackgroundRoutes: FC<RouteComponentProps> = () => {
  return (
    <Switch>
      <Redirect
        exact
        from={`${MDRT_HUB_BASE_PATH}${MDRT_PASSPORT_BACKGROUND_BASE_PATH}`}
        to={`${MDRT_HUB_BASE_PATH}${MDRT_PASSPORT_BACKGROUND_BASE_PATH}/list`}
      />
      <PruRoute
        exact
        path={`${MDRT_HUB_BASE_PATH}${MDRT_PASSPORT_BACKGROUND_BASE_PATH}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={[]}>
            <MdrtPassportBackgroundListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute
        exact
        path={`${MDRT_HUB_BASE_PATH}${MDRT_PASSPORT_BACKGROUND_BASE_PATH}/edit/:id`}
        component={MdrtPassportBackgroundDetailPage}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default MdrtPassportBackgroundRoutes;
